import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Divider, Link, TextField, Box } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import gradients from 'utils/gradients';
import { useMutation, useApolloClient } from '@apollo/react-hooks';
import { loader } from 'graphql.macro';
import { useHistory } from 'react-router';
import Base from './Base';
import ButtonWithCircularProgress from 'components/ButtonWithCircularProgress';

const LoginMutation = loader('graphql/mutations/Login.graphql');

const useStyles = makeStyles(theme => ({
    icon: {
        backgroundImage: gradients.green,
        color: theme.palette.white,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        position: 'absolute',
        top: -32,
        left: theme.spacing(3),
        height: 64,
        width: 64,
        fontSize: 32
    },
    loginForm: {
        marginTop: theme.spacing(3)
    },
    divider: {
        margin: theme.spacing(2, 0)
    },
    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }
    },
    links: {
        maxWidth: '100%',
        display: 'flex',
        '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%'
        }
    }
}));

const Login = () => {
    const classes = useStyles();
    const client = useApolloClient();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [login, { loading, error }] = useMutation(LoginMutation, {
        onCompleted: () => {
            client.writeData({ data: { isConnected: true } });
            history.push('/');
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmit(true);
        login({ variables: { input: { email: email, password: password } } });
    };

    const hasErrorEmail = () => {
        return submit && error && (
            error.message.includes('need signup') ||
            error.message.includes('not found') ||
            error.message.includes('deleted')
        );
    };

    const getErrorEmail = () => {
        if (!submit) return null;
        if (error && error.message.includes('need signup')) return 'Inscription nécessaire.';
        if (error && error.message.includes('not found')) return 'Cette adresse mail n\'est pas enregistrée.';
        if (error && error.message.includes('deleted')) return 'Compte supprimé.';
        return null;
    };

    const hasErrorPassword = () => {
        return submit && error && error.message.includes('invalid password');
    };

    return (
        <Base title="Se connecter" subtitle="Se connecter pour accéder aux ouvertures" icon={<LockIcon className={classes.icon} />}>
            <form className={classes.loginForm} onSubmit={handleSubmit}>
                <div className={classes.fields}>
                    <TextField fullWidth label="Adresse mail" name="email" variant="outlined"
                        value={email} onChange={e => { setSubmit(false); setEmail(e.target.value); }}
                        error={hasErrorEmail()} helperText={getErrorEmail()} />
                    <TextField fullWidth label="Mot de passe" name="password" type="password" variant="outlined"
                        value={password} onChange={e => { setSubmit(false); setPassword(e.target.value); }}
                        error={hasErrorPassword()} helperText={hasErrorPassword() ? "Le mot de passe est incorrect." : null} />
                </div>
                <Box marginTop={2}>
                    <ButtonWithCircularProgress size="large" type="submit" loading={loading} disabled={email === "" || password === "" || loading}
                        label="Se connecter" fullWidth />
                </Box>
            </form>
            <Divider className={classes.divider} />
            <div className={classes.links}>
                <Link align="left" color="secondary" component={RouterLink} to="/signup" underline="always" variant="subtitle2">
                    {'Pas encore de compte?'}
                </Link>
                <Link align="right" color="secondary" component={RouterLink} to="/requestResetPassword" underline="always" variant="subtitle2">
                    {'Mot de passe oublié?'}
                </Link>
            </div>
        </Base>
    );
};

export default Login;